<template>
  <div
    v-if="opened && $features?.getValue('app_prompt_minimal') === 'on'"
    class="fixed flex md:hidden items-center justify-between inset-x-0 z-40 top-4 btn btn-green rounded-full w-2/3 mx-auto py-2 px-4"
  >
    <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-sm"   alt="" svg-inline  fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path d="M1.3 12c-.3 0-.6-.1-1-.4-.2-.3-.3-.6-.3-1V1.4C0 1 .1.7.4.3.7.2 1 0 1.4 0H6v1.3H1.3v9.4h9.4V6H12v4.7c0 .3-.1.6-.4 1-.3.2-.6.3-1 .3H1.4Zm3.2-3.5-1-1 6.2-6.2H7.3V0H12v4.7h-1.3V2.3L4.5 8.5Z" fill="#fff"/></svg>
    <a :href="link" @click="trackClick">
      <span class="font-medium">{{ $t('prompt.open_in_the_app') }}</span>
    </a>

    <button @click="opened = false" class="block border-brand-900 border-l pl-2">
      <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-sm pb-1"   alt="close" svg-inline  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32"><title>close</title>
  <path fill="currentColor" d="M24.63 3.06a3.05 3.05 0 1 1 4.31 4.3L7.37 28.95a3.05 3.05 0 0 1-4.31-4.3L24.63 3.05Z"/>
  <path fill="currentColor" d="M28.94 24.63a3.05 3.05 0 0 1-4.3 4.31L3.05 7.37a3.05 3.05 0 1 1 4.3-4.31l21.58 21.57Z"/>
</svg>
    </button>
  </div>
</template>
<script lang="ts" setup>
import { AppPromptClick } from '@core/analytics/core-events/app'

const { $track, $features } = useNuxtApp()

const opened = ref(true)

const link = useAppLink('prompt_minimal')

async function trackClick() {
  await $track(AppPromptClick('minimal'))
}
</script>
